import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone, inject } from '@angular/core';
import { ApiMessageService } from './api-message.service';
import { MsgService } from './msg.service';
import { HTTP_STATUS_MESSAGES, DEFAULT_ERROR_MESSAGE } from '../../../Consts/error-messages.const';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  private readonly _msgService = inject(MsgService);
  private readonly _apiMessageService = inject(ApiMessageService);
  private readonly _zone = inject(NgZone);

  handleError(error: HttpErrorResponse): void {
    if (error.status === 0 || error.status === 401) {
      return;
    }

    this._zone.run(() => {
      this._msgService.showSnackBar(this._resolveMessage(error), {
        type: 'error',
        duration: 5000,
      });
    });
  }

  messageFor(error: unknown): string {
    return error instanceof HttpErrorResponse ? this._resolveMessage(error) : DEFAULT_ERROR_MESSAGE;
  }

  private _resolveMessage(error: HttpErrorResponse): string {
    return (
      this._apiMessageService.fromEnvelope(error.error) ??
      this._apiMessageService.validationSummary(error.error) ??
      HTTP_STATUS_MESSAGES[error.status] ??
      DEFAULT_ERROR_MESSAGE
    );
  }
}
